import * as s from "./website-black-search-cases.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {IWebsiteBlackSearchCases} from "./types/IWebsiteBlackSearchCases";

export class WebsiteBlackSearchCasesComponent extends Component {
    constructor(p: IWebsiteBlackSearchCases) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackSearchCases}">
                <div class="${s.title}">
                    ${p.title}
                </div>
                <div class="${s.cases}">
                    ${p.cases.map(value => `
                    <div class="${s.case}">
                        <div class="${s.name}">
                            ${value.name}
                        </div>
                        <div class="${s.value}">
                            ${value.value.replace("->",`<div class="${s.arrow}"></div>`)}
                        </div>
                    </div>
                    `).join("")}
                </div>
            </div>
        `;
    }
}